import { MFA_SEND, MFA_VERIFY } from '../../constants';
import { api } from '../api';
import { MfaSendReqBody, MfaVerifyReqBody, MfaVerifyResponse } from './types';

export const mfaSlice = api.injectEndpoints({
  endpoints: (build) => ({
    mfaVerify: build.mutation<MfaVerifyResponse, MfaVerifyReqBody>({
      query(data) {
        return {
          url: MFA_VERIFY,
          method: 'POST',
          body: data
        };
      }
    }),
    mfaSend: build.mutation<void, MfaSendReqBody>({
      query(data) {
        return {
          url: MFA_SEND,
          method: 'POST',
          body: data
        };
      }
    })
  }),

  overrideExisting: false
});

export const { useMfaVerifyMutation, useMfaSendMutation } = mfaSlice;
